export default {
    最新公告:'最新公告',
    公司治理:'公司治理',

    companyProfile:{
       title:'公司简介',
       desc:'<div>我们是一家成立于1988年，并于2005年在深圳证券交易所上市的，专业从事中高档乘用车零部件的设计、开发、生产、销售及售后服务的跨国集团公司，全球总部位于中国，并在北美、欧洲、南亚均拥有分支机构，全球拥有超过60家生产基地及3家区域研发中心，员工逾15,000人。</div>' +
       '<div>作为世界汽配五百强企业， 我们为众多国际知名汽车品牌提供内外饰件、车身金属件、汽车电子等产品和相关服务。我们的主要客户包括：大众、宝马、福特、通用、捷豹路虎、奔驰、丰田、沃尔沃、上海汽车、一汽轿车、东风日产等。</div>' +
       "<div>我们秉持“为每位员工创造能发挥价值的舞台”的理念， 以“坚持持续的盈利能力，坚持稳健的财务政策；让股东受益，让客户满意，让合作者发展”为宗旨，致力于前瞻的技术创新并成为全球汽车行业优秀供应商。</div>"
   },
    products:{
        title:'核心产品',
        desc:'公司专业从事汽车零部件设计开发、生产及销售，<br>产品涵盖汽车内外饰、车身金属件、汽车电子和新能源汽车相关产品。'
    },
    investorRelations:{
        name:'宁波华翔 (002048)',
        dayHigh:'今日最高价',
        dayOpen:'今日开盘价',
        dayLow:'今日最低价',
        yesterdayClose:'昨日收盘价',
        volume:'成交量(万手)',
        turnover:'成交额(万元)'
    },
    news:{
        title:'企业动态',
    },
}